<template>
<div class="chapter">
<div class="inner_page">
<h1>The Michael Gray Series</h1>
<h2 class="sigil_not_in_toc" style="text-align: center;">Henry Kuttner and C.L. Moore</h2>
<h3 class="sigil_not_in_toc"><a href="#/Text/01_title">The Murder of Eleanor Pope</a><br/>
<span href="#/Text/01_title_" title="Link target outside of Sample">The Murder of Ann Avery</span><br/>
<span href="#/Text/04_title" title="Link target outside of Sample">Murder of a Mistress</span><br/>
<span href="#/Text/_03_title" title="Link target outside of Sample">Murder of a Wife</span><br/></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?843dd90c